<div class="form-presence" *ngIf="viewers.length > 0">
	<div class="form-presence__avatars">
		<div
			*ngFor="let viewer of visibleViewers"
			[class]="getAvatarClass(viewer)"
			[title]="getTooltip(viewer)"
			[attr.aria-label]="getTooltip(viewer)"
			tabindex="0"
		>
			{{ getInitials(viewer) }}
			<span class="presence-avatar__mode-icon" [title]="getTooltip(viewer)" [attr.aria-label]="getTooltip(viewer)">
				<i *ngIf="viewer.mode === 'edit'" class="fa fa-edit" aria-hidden="true"></i>
				<i *ngIf="viewer.mode === 'view'" class="fa fa-eye" aria-hidden="true"></i>
			</span>
		</div>
		<div
			*ngIf="overflowCount > 0"
			class="presence-avatar presence-avatar--overflow"
			[title]="overflowTooltip"
			[attr.aria-label]="overflowTooltip"
			tabindex="0"
		>
			+{{ overflowCount }}
		</div>
	</div>
</div>
